define('commons/default-runtimes-snos-selector',['jquery', 'commons/runtimes-snos-selector'], function($) {
	
    var DefaultRuntimesSnosSelector = function(containerSelector, options) {
        var self = this;
        
        // Configuration settings
        this.settings = {
        	listUrl: "",
        	defaultUrlBase: "",
            beforeOpenDialog: function() {},
            onOkSuccess: function(data) {},
            onOkError: function(jqXHR, textStatus, errorThrown) {},
        };
        $.extend(true, this.settings, options);
   
    
	    this.snosSelector = $(containerSelector).snoSelector({
	        listUrl: self.settings.listUrl,
	        onOkClick: function(data) {
	            this.dialog('close');
	            $.ajax({
	                type: 'POST',
	                url: self.settings.defaultUrlBase + data[1],
	                data: {
	                    'snoIds': data[0],
	                    'isDefault' : data[2],
	                    'hardwareId': data[3],
	                    'isSetMode' : data[4]
	                },
	                traditional: true,
	                error: function(jqXHR, textStatus, errorThrown) {
	                	self.onError(jqXHR, textStatus, errorThrown);
	                },
	                success: function() {
	                	self.onSuccess(data);
	                }
	            });
	        }
	    });
	    
	    this.bindSetCurrent();
    }
    
    DefaultRuntimesSnosSelector.prototype.beforeOpenDialog = function() {
         this.settings.beforeOpenDialog.call(this);
    }
    
    DefaultRuntimesSnosSelector.prototype.onSuccess = function(data) {
        this.settings.onOkSuccess.call(this, data);
   }
    
    DefaultRuntimesSnosSelector.prototype.onError = function(jqXHR, textStatus, errorThrown) {
        this.settings.onOkError.call(this, jqXHR, textStatus, errorThrown);
   }

    DefaultRuntimesSnosSelector.prototype.onUpgradeRuntime = function(version, id, hwVersion, hwId) {
        this.snosSelector.version = version;
        this.snosSelector.runtimeId = id;
        this.snosSelector.hardwareId = hwId;
        this.snosSelector.hwVersion = hwVersion;
        this.snosSelector.settings.title= "Set/unset runtime " + version +" to SOs for all compatible hardware";
        if(hwVersion != undefined) {
            this.snosSelector.settings.title= "Set/unset runtime " + version + " to SOs for hardware " + hwVersion;
        }
        this.snosSelector.settings.refresh = true;
        this.snosSelector.snoSelector('open');
    };

    DefaultRuntimesSnosSelector.prototype.bindSetCurrent = function() {
    	var self = this;
        this.snosSelector.snoSelector('close');
        $('.set-current').each(function(link) {
            $(this).off().on("click", function(){
               var version = $(this).attr("data-version");
               var hwVersion = $(this).attr("data-hw-version");
               var hwId = $(this).attr("data-hw-id");
               var id = $(this).attr("data-id");
               self.beforeOpenDialog();
               self.onUpgradeRuntime(version, id, hwVersion, hwId);
            });
        });
	}
    
    return DefaultRuntimesSnosSelector;
    
});
